declare var Rellax: any;
declare var _sr: any;

import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-case',
  templateUrl: './case.component.html',
  styleUrls: ['./case.component.scss'],
})
export class CaseComponent implements OnInit {

    static componentName = 'CaseComponent';
    case: any;
    slug: String;
    fieldValues: {[k: string]: any} = {};
    fieldSelectors: Array<any> = ['video_ids', 'boxed_images', 'fluid_image', 'second_content', 'second_boxed_image', 'quote', 'quote_by'];

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
    ) {}

    getCase(): void {
        this.dataService.getPost('case/' + this.slug)
            .subscribe(res => this.case = res);
    }

    getField(field_selector): any {
        this.dataService.getField('case/' + this.slug, null, field_selector)
            .subscribe(res => this.fieldValues[field_selector] = res[field_selector]);
    }

    ngOnInit() {
        this.route.params
            .subscribe(params => {
                if (typeof this.slug !== 'undefined') {
                    this.slug = params.slug;
                    this.getCase();

                    if (typeof window !== 'undefined') {
                        window.scrollTo(0, 0);
                        window.location.reload();
                    }
                }

                this.slug = params.slug;
                this.getCase();
            });

        // Fetch all ACF fields
        for (const fieldSelector in this.fieldSelectors) {
            if (this.fieldSelectors.hasOwnProperty(fieldSelector)) {
                this.getField(this.fieldSelectors[fieldSelector]);
            }
        }

        setTimeout(() => {
            _sr.reveal('app-content section.content div.content-wrap');
        }, 1000);

        setTimeout(() => {
            if (document.querySelectorAll('.rellax').length) {
                const rellax = new Rellax('.rellax');
            }
        }, 700);

        setTimeout(() => {
            if (document.querySelectorAll('.case-hero').length) {
                document.querySelectorAll('.case-hero')[0].classList.add('show');
            }
        }, 1300);
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/case/case.component.ts